import { render, staticRenderFns } from "./notice-area.vue?vue&type=template&id=4241cf70&lang=pug&"
import script from "./notice-area.vue?vue&type=script&lang=js&"
export * from "./notice-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports